<script lang="ts">
    import {Col,Row } from "sveltestrap";
    import Card from "../../UiCommenCard.svelte";
    import UnorderList from "./UnorderList.svelte";
    import OrderList from "./OrderList.svelte";
    import Fontawesomelist from "./Fontawesomelist.svelte";
    import Iconlist from "./Iconlist.svelte";
    import Themfylist from "./Themfylist.svelte";
    import Order2list from "./Order2list.svelte";
    import { ListingTypography } from "../../../../utils/Constant/Constant";

</script>
<Col sm="12" class="listing">
    <Card cardHeaderprops="pb-0" headerTitle={ListingTypography}>
      <div slot="contentbody">
        <Row>
          <UnorderList/>
          <OrderList/>
          <Order2list/>
          <Fontawesomelist/>
          <Iconlist/>
          <Themfylist/>
        </Row>
      </div>
    </Card>
</Col>